export const environment = {
    production: false,
    apiHost: '',
    basePath: 'https://api.ttstore.site/api/v1',
    accessKey: '&@so8To84EXKF',
    firebaseConfig: {
        apiKey: 'AIzaSyBw0YzuJGR7OG9wLLuuhauVuoWTCHUduCw',
        authDomain: 'devttstore.firebaseapp.com',
        projectId: 'devttstore',
        storageBucket: 'devttstore.firebasestorage.app',
        messagingSenderId: '150855224579',
        appId: '1:150855224579:web:c1eced12e0239d36d9ad36',
        measurementId: 'G-8WZY67EV4K',
    },
    googleFontApiKey: 'AIzaSyBPWObqUe5CJvRqztBSAAqqEvzCw9UyzWU',
};
